export default __webpack_public_path__ + "static/media/041-paint brush.1a5b890c.svg";